<div class="user-form-container">
  <div class="sub-header">
    <button mat-icon-button aria-label="Go Back" class="back-button" (click)="onGoBack()">
      <mat-icon class="back-icon">chevron_left</mat-icon>
    </button>
    <h1 class="page-title">Add New User</h1>
  </div>

  <div class="form-wrapper">
    <mat-card class="form-card">
      <mat-card-content>
        <form [formGroup]="registerForm" (ngSubmit)="onSubmit($event)">

          <div class="form-section" *ngIf="isSuperAdmin">
            <h2 class="section-title">Company & Consultant Selection</h2>
            <div class="form-row">
              <mat-form-field class="form-field">
                <mat-label>Company</mat-label>
                <mat-select formControlName="company" (selectionChange)="onCompanySelect($event.value)">
                  <mat-option value="">Select Company</mat-option>
                  <mat-option *ngFor="let company of companies" [value]="company">
                    {{company.name}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="this.registerForm.get('company')?.touched && this.registerForm.get('company')?.hasError('required')">
                  Company is required
                </mat-error>
              </mat-form-field>

              <mat-form-field class="form-field" [hidden]="!selectedCompany || filteredClients.length === 0">
                <mat-label>Consultant</mat-label>
                <mat-select formControlName="consultant" (selectionChange)="onClientSelect($event.value)" [disabled]="!selectedCompany || filteredClients.length === 0">
                  <mat-option value="">Select Consultant</mat-option>
                  <mat-option *ngFor="let client of filteredClients" [value]="client">
                    {{client.firstname}} {{client.lastname}} ({{client.email}})
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="this.registerForm.get('consultant')?.touched && this.registerForm.get('consultant')?.hasError('required')">
                  Consultant is required
                </mat-error>
              </mat-form-field>
            </div>

            <!-- <div class="form-row" *ngIf="selectedCompany && clients.length > 0">
              <mat-form-field class="form-field full-width">
                <mat-label>Search Consultant</mat-label>
                <input type="text" matInput placeholder="Search by name or email" 
                  (keyup)="onClientSearch($any($event.target).value)">
                <mat-hint>Search by first name, last name, or email</mat-hint>
              </mat-form-field>
            </div> -->
          </div>

          <div class="form-section">
            <h2 class="section-title">Personal Information</h2>
            <div class="form-row">
              <mat-form-field class="form-field">
                <mat-label>First Name</mat-label>
                <input type="text" matInput placeholder="Enter first name" formControlName="firstname">
                <mat-error *ngIf="this.registerForm.get('firstname')?.touched && this.registerForm.get('firstname')?.hasError('required')">
                  First Name is required
                </mat-error>
              </mat-form-field>

              <mat-form-field class="form-field">
                <mat-label>Last Name</mat-label>
                <input type="text" matInput placeholder="Enter last name" formControlName="lastname">
                <mat-error *ngIf="this.registerForm.get('lastname')?.touched && this.registerForm.get('lastname')?.hasError('required')">
                  Last Name is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="form-field">
                <mat-label>Email</mat-label>
                <input type="email" matInput placeholder="Enter email address" formControlName="email">
                <mat-error *ngIf="this.registerForm.get('email')?.touched && this.registerForm.get('email')?.hasError('required')">
                  Email is required
                </mat-error>
                <mat-error *ngIf="this.registerForm.get('email')?.touched && this.registerForm.get('email')?.hasError('email')">
                  Email must be a valid email address
                </mat-error>
              </mat-form-field>

              <mat-form-field class="form-field">
                <mat-label>Birth Date</mat-label>
                <input matInput [matDatepicker]="picker" placeholder="MM/DD/YYYY" formControlName="birthDate"
                  [min]="minStartDate" [max]="maxBirthDate" (dateChange)="dateChangeHandler($event.value)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker [disabled]="false"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-row">
              <div class="gender-section">
                <label class="gender-label">Gender</label>
                <mat-radio-group class="radio-group" formControlName="gender">
                  <mat-radio-button value="m">Male</mat-radio-button>
                  <mat-radio-button value="f">Female</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>

          <div class="form-section">
            <h2 class="section-title">Contact Information</h2>
            <div class="form-row">
              <mat-form-field class="form-field">
                <mat-label>Country</mat-label>
                <mat-select (valueChange)="selectCountry($event)" [(value)]="selectedCountry">
                  <mat-option value="US">USA</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field class="form-field mobile-field">
                <mat-label>Mobile Phone</mat-label>
                <input matInput placeholder="Enter phone number" formControlName="mobilephone" type="number">
                <mat-error *ngIf="this.registerForm.get('mobilephone')?.touched && this.registerForm.get('mobilephone')?.hasError('required')">
                  Mobile Number is required
                </mat-error>
                <mat-error *ngIf="this.registerForm.get('mobilephone')?.hasError('message')">
                  {{this.registerForm.get('mobilephone').errors?.message}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-section">
            <h2 class="section-title">Address Information</h2>
            <div class="form-row">
              <mat-form-field class="form-field full-width">
                <mat-label>Street Address</mat-label>
                <input type="text" matInput placeholder="Enter street address" formControlName="address">
                <mat-error *ngIf="this.registerForm.get('address')?.touched && this.registerForm.get('address')?.hasError('required')">
                  Address is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="form-field">
                <mat-label>Apt / Suite</mat-label>
                <input type="text" matInput placeholder="Apt, suite, etc. (optional)" formControlName="aptsuite">
              </mat-form-field>

              <mat-form-field class="form-field">
                <mat-label>City</mat-label>
                <input type="text" matInput placeholder="Enter city" formControlName="city">
                <mat-error *ngIf="this.registerForm.get('city')?.touched && this.registerForm.get('city')?.hasError('required')">
                  City is required
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="form-field">
                <mat-label>State</mat-label>
                <mat-select formControlName="state">
                  <mat-option value="">Select state</mat-option>
                  <mat-option *ngFor="let data of selectData" [value]="data.stateCode">
                    {{data.stateName}}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="this.registerForm.get('state')?.touched && this.registerForm.get('state')?.hasError('required')">
                  State is required
                </mat-error>
              </mat-form-field>

              <mat-form-field class="form-field">
                <mat-label>Postal Code</mat-label>
                <input type="text" matInput placeholder="Enter postal code" formControlName="postalcode">
                <mat-error *ngIf="this.registerForm.get('postalcode')?.touched && this.registerForm.get('postalcode')?.hasError('required')">
                  Postal Code is required
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="form-footer">
            <div class="error-message" *ngIf="isDisplayFieldsRequired">
              <mat-icon class="error-icon">error_outline</mat-icon>
              <span>All fields are required. Please fill out all fields.</span>
            </div>
            <div class="button-group">
              <button mat-stroked-button type="button" (click)="onGoBack()">Cancel</button>
              <button mat-flat-button color="primary" type="submit">Submit</button>
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>